import { Resource } from '../../http/resource/resource.model';

export class Portal extends Resource {
  // id is inherited from Resource
  main_setting_id: number;
  status: number;
  name: string;
  title: string;
  days_before_evaluation: number;
  allow_registered_alt: number;
  allow_absent_alt: number;
  logo: string;
  institutional_color: string;
  favicon: string;
  background: string;
  option_domain: number;
  system_domain: number;
  edited_by: string;
  tbc: string;
  totvs_user: string;
  totvs_pass: string;
  deleted_at: string;
  created_at: string;
  updated_at: string;
}
